import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowSplitUp: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArrowSplitUp"><Path d="M3.5 9.5V3.5H9.5" stroke="currentColor" strokeLinecap="square"/><Path d="M14.5 3.5H20.5V9.5" stroke="currentColor" strokeLinecap="square"/><Path d="M12 12V20.5M12 12L4 4M12 12L20 4" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconArrowSplitUp;
